import { SelectOption } from '../../../../../../../ui/gzDropdown/types';

export enum PatchManagementEvents {
  OnMaintenanceWindowOptionSelect = 'onMaintenanceWindowOptionSelect',
  OnAddWindowClick = 'onAddWindowClick',
}

export interface MaintenanceWindowSelectOption extends SelectOption {
  value: string;
}

export class OnMaintenanceWindowOptionSelect extends CustomEvent<{
  oldValue: MaintenanceWindowSelectOption;
  newValue: MaintenanceWindowSelectOption;
}> {
  constructor(oldValue: MaintenanceWindowSelectOption, newValue: MaintenanceWindowSelectOption) {
    super(PatchManagementEvents.OnMaintenanceWindowOptionSelect, {
      detail: {
        oldValue,
        newValue,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnAddWindowClick extends CustomEvent<void> {
  constructor() {
    super(PatchManagementEvents.OnAddWindowClick, {
      bubbles: true,
      composed: true,
    });
  }
}
